import { render, staticRenderFns } from "./RecruitingPage.vue?vue&type=template&id=234951fd&scoped=true&lang=pug&"
import script from "./RecruitingPage.vue?vue&type=script&lang=ts&"
export * from "./RecruitingPage.vue?vue&type=script&lang=ts&"
import style0 from "./RecruitingPage.vue?vue&type=style&index=0&id=234951fd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234951fd",
  null
  
)

export default component.exports